export interface StartMessageThreadRequest {
  body: string;
  subject: string;
  attachmentIds: [];
}

export interface StartMessageThreadResponse {
  id: string;
}

export enum MessageTemplate {
  INCREASE_CARD_LIMITS = 'increaseCardLimits',
  RAISE_TRANSACTIONAL_LIMITS = 'raiseTransactionalLimits'
}

export function MessageTemplateExsists(template: string): boolean {
  return Object.values(MessageTemplate).includes(template as MessageTemplate);
}
